import styled from "styled-components";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { IColors, ITheme } from "@swiggy-private/dls-web-common/dist/components/types";
import { DeliveryTagInfoUIDataMweb } from "@super-ui/interfaces";

// Possible Tokens values based on variants
// pillBgColor: "positive_Sub", textColor: "positive",
// pillBgColor: "highlight_Sub", textColor: "highlight",
const colorPickerFromDLS = (colorKey: string, theme: ITheme): string => {
    return theme.colors[theme.colorMode][colorKey as keyof IColors];
};

type DeliveryTagColors = Pick<DeliveryTagInfoUIDataMweb, "pillBgColor" | "textColor">;

export const Container = styled.div(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: theme.cornerRadius.xSmall,
    overflow: "hidden",
    width: "88px",
    marginLeft: theme.spacing.xSmall,
}));

export const DeliveryCountText = styled(Text)<DeliveryTagColors>(props => ({
    width: "100%",
    textAlign: "center",
    backgroundColor: colorPickerFromDLS(props.pillBgColor, props.theme),
    color: colorPickerFromDLS(props.textColor, props.theme),
    padding: props.theme.spacing.xxxSmall,
    paddingBottom: 0,
}));

export const SubText = styled(Text)<DeliveryTagColors>(props => ({
    width: "100%",
    fontSize: "9px",
    textAlign: "center",
    backgroundColor: colorPickerFromDLS(props.textColor, props.theme),
    color: props.theme.colors[props.theme.colorMode].background_Primary,
    padding: `0 ${props.theme.spacing.xxSmall}`,
    textTransform: "capitalize",
}));
